import React, { Component } from 'react';
import styles from './header.css';
import logo from '../../assets/images/logo.png';
import logo_retina from '../../assets/images/logo@2x.png';
import gtx_logo from '../../assets/images/logo_gtx.png';
import gtx_logo_retina from '../../assets/images/logo_gtx@2x.png';
//import search_icon from '../../assets/icons/icon_search.svg';
import Lang from '../../i18n'
import {
  Link,
  withRouter
} from 'react-router-dom'

class Header extends Component {

  constructor(props){
    super(props)
    this.state = {
      showDropdown: false
    }
  }

  returnLanguageArray = () => {
    const languages = Lang.availableLanguages()
    return languages.map((value) => {
      return(
        <li key={`lang-${value.id}`} style={{width: '100%'}}>
          <Link to={value.code.toLowerCase()} onClick={() => this.toggleDropdown()} style={{color: '#0D2EA0', width: '100%', display: 'block', margin: '.75em 0', textDecoration: 'none'}}>{value.displayString}</Link>
        </li>
      )
    })
  }

  toggleDropdown = () => {
    this.setState({
      showDropdown: this.state.showDropdown ? false : true
    })
  }

  render() {
    const activeOpacity = this.state.showDropdown ? 1 : 0
    return (
      <div className={styles.header}>
        <div className={styles.header__inner} style={{position: 'relative'}}>
          <a className={styles.logo} href="/">
            <img src={logo} srcSet={logo + " 1x, " + logo_retina + " 2x"} alt="" />
          </a>
          <img className={styles.header__center} src={gtx_logo} srcSet={gtx_logo + " 1x , " + gtx_logo_retina + " 2x"} alt="" />
          <button onClick={() => this.toggleDropdown()} style={{marginLeft: '-3em', backgroundColor: 'transparent', border: 0, cursor: 'pointer', marginRight: '1.5em'}}>
            <span style={{fontSize: 16, color: 'white', marginRight: '.5em', textTransform: 'uppercase'}}>{Lang.getLanguageFromUrl(this.props.location.pathname)}</span>
            <svg width="12px" height="7px" viewBox="0 0 12 7" version="1.1" xmlns="http://www.w3.org/2000/svg">
              <g id="Desktop" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="BRO18I01_Printer_Tool_01_XS" transform="translate(-1337.000000, -31.000000)" fill="#FFFFFF">
                  <g id="Nav">
                    <polygon id="Rectangle-14" transform="translate(1342.662111, 31.662111) rotate(45.000000) translate(-1342.662111, -31.662111) " points="1346.66211 27.6546767 1346.66211 35.669546 1338.66211 35.669546"></polygon>
                  </g>
                </g>
              </g>
            </svg>
          </button>
          <ul style={{position: 'absolute', right: 0, top: '2.1em', zIndex: 5, backgroundColor: 'white', listStyle: 'none', padding: '1em 3em 1em 2em', transition: 'all .2s', opacity: activeOpacity}}>
            { this.returnLanguageArray() }
          </ul>
        </div>
      </div>
    );
  }
}

export default withRouter(Header);



// WEBPACK FOOTER //
// ./src/components/header/header.js